export default "__VITE_ASSET__BymkDfp8__"